export default [
	{
		settings: true,
		width: '60px',
		text: "Id",
		value: "id",
		func: true,
		valueFilter: 'filter_id',
		model: { value: 'list' },
		sortable: true,
		footer: "unique",
	},
	{
		settings: true,
		text: "City",
		value: "city",
		func: true,
		valueFilter: 'filter_city',
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "ZIP",
		value: "zip_codes",
		func: true,
		valueFilter: 'filter_zip_code',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "State",
		value: "state",
		func: true,
		valueFilter: 'filter_state',
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		width: '80px',
		buttons: [
			{
				perm: { or: [ 9 ] },
				value: 'edit',
				text: 'Edit city',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete city',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		]
	},
];
